import React from 'react';
import { CheckSquare, X } from 'lucide-react';
import { toDateKey, parseDateKey } from '../utils/date';

const TaskModal = ({ show, onClose, newTask, setNewTask, selectedDate, setSelectedDate, addTask }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-gray-900 flex items-center">
            <CheckSquare className="h-6 w-6 mr-3" style={{ color: '#8D6E63' }} />
            Nueva Tarea
          </h3>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Descripción</label>
            <input
              type="text"
              value={newTask}
              onChange={(e) => setNewTask(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:border-transparent"
              placeholder="¿Qué necesitas hacer?"
              onKeyPress={(e) => e.key === 'Enter' && addTask()}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Fecha</label>
            <input
              type="date"
              value={toDateKey(selectedDate)}
              onChange={(e) => e.target.value && setSelectedDate(parseDateKey(e.target.value))}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:border-transparent"
            />
          </div>
        </div>
        
        <div className="flex space-x-4 mt-8">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all font-semibold"
          >
            Cancelar
          </button>
          <button
            onClick={addTask}
            className="flex-1 px-6 py-3 text-white rounded-xl transition-all font-semibold"
            style={{ background: 'linear-gradient(135deg, #C8A88C 0%, #A1887F 100%)' }}
          >
            Crear Tarea
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskModal;